import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Inputid from './Inputid';
import ChooseType from './chooseType';

class FormContent extends React.PureComponent {
    static propTypes = {};

    state = {
        next: false,
        userInfo: [],
        account: '',
    };

    handleOnchange = (params, account) => {
        // console.log(params);
        if (params && (params.mail || params.mobile)) {
            const userInfo = [];

            Object.keys(params).forEach(key => {
                if (params[key]) {
                    userInfo.push({
                        type: key,
                        data: params[key],
                    });
                }
            });

            this.setState({ next: true, userInfo, account });
        }
    };

    render() {
        const { next, userInfo, account } = this.state;

        return (
            <div className={styles.formContent}>
                <h2 className={styles.title}>找回凤凰通行证密码</h2>
                <div className={styles.box}>
                    {!next ? (
                        <div className={styles.formList}>
                            <div className={styles.tip}>请填写您需要找回的账号:</div>
                            <Inputid onNext={this.handleOnchange} />
                        </div>
                    ) : (
                        <div className={styles.findType}>
                            <div className={styles.findType_tit}>请选择找回密码的方式:</div>
                            <ChooseType userInfo={userInfo} account={account} />
                        </div>
                    )}
                    <div className={styles.bot} />
                </div>
                {/* {index === 0 ? <LoginById /> : <LoginByPhone />} */}
            </div>
        );
    }
}

export default errorBoundary(FormContent);
